<template>
  <b-container class="align-items-center" style="margin-top:200px; max-width: 700px">
    <div v-if="!resetting_password">
      <span style="font-weight: bold; font-size: 1.8rem; color: steelblue">Fleet Integrations Portal</span>
      <hr/>
        <b-form @submit.prevent="login" style="color:white">
            <b-form-group
                label="Email address"
            >
                <b-form-input
                    id="username"
                    v-model="form.username"
                    type="text"
                    required
                    placeholder="Enter username"
                />
            </b-form-group>
            <b-form-group
                label="Password">
                <b-form-input
                    id="password"
                    v-model="form.password"
                    type="password"
                    required
                    placeholder="Enter your password"
                ></b-form-input>
            </b-form-group>
            <br/>
            <div>
                <b-button v-if="!loading"
                          id="login-button"
                    type="submit"
                    size="md"
                >Login</b-button>
            </div>
        </b-form>
        <br/>
        <div class="text-center" style="font-weight: bold; font-size: 20px;" v-if="loading">
          processing login request...
          <br/><br/>
        </div>
        <div class="text-center" style="font-weight: bold; font-size: 20px; color: red" v-if="errored">
          {{alert.message}}
          <br/><br/>
        </div>
        <div class="text-center">
          <b-link style="font-weight: bold; font-size: 20px;" @click="auth_navigation">
            Reset password
          </b-link>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <router-link style="font-weight: bold; font-size: 20px;" :to="{ path: '/register' }">Register Your Company</router-link>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <a style="font-weight: bold; font-size: 20px;" target="_new" href="https://www.initekconsulting.com/fleet-integrations">Info</a>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <a style="font-weight: bold; font-size: 20px" target="_new" href="mailto:support@initekconsulting.com">Contact Us</a>
        </div>
      <div style="color: #007ac7; font-family: 'inherit' ;font-size: 24px; margin:50px 0px 50px 0px; padding:20px; border-top: 2px dotted #ccc;">
        powered by &#8594; <a target="_new" href="https://www.initekconsulting.com/fleet-integrations"><img height="40" src="/initek-logo.png"/></a>
      </div>
    </div>
    <div v-else>
      <ForgotPassword
          @auth_navigation="auth_navigation"
      />
    </div>
  </b-container>
</template>

<script>
    import axios from 'axios'
    import {mapMutations} from "vuex";
    import ForgotPassword from './forgot_password'

    export default {
        name: 'login',
        components: { ForgotPassword },
        data() {
            return {
                loading: false,
                errored: false,
                form: { username:'', password:''},
                alert: { show:false, message:'', variant:''},
                resetting_password: false,
                jwt: null,
            }
        },
        created(){
          localStorage.clear()
          this.$emit('authenticated', false)
        },
        methods: {
          auth_navigation(bool){
            this.resetting_password = bool
          },
            async login() {
                if(this.form.username != "" && this.form.password != "") {
                    this.loading = true
                    this.errored = false
                    axios.post(
                        process.env.VUE_APP_API_URL + "bookings/auth/login",
                        this.form,
                        {headers: {'Access-Control-Allow-Origin': '*'}}
                    ).then((response) => {
                      this.handle_login_response(response.data);
                    }).catch(error => {
                      if (error.message && error.message == "Network Error")
                         this.alert = {show: true, message: "system in currently unavailable, try again later or contact support", variant: 'danger'}
                      else
                        this.alert = {show: true, message: "unable to login, check username & password or contact support", variant: 'danger'}
                      this.errored = true
                      this.loading = false
                    });
                }
            },
            async handle_login_response(data) {
                setTimeout(() => {
                    localStorage.setItem('user', JSON.stringify(data.data.user))
                    localStorage.setItem('jwt', data.data.token)
                    localStorage.setItem('authenticated', true)

                    const jwt_data = this.h_get_jwt_data(data.data.token);
                    localStorage.setItem('expiration_token_time', jwt_data.exp);

                    this.set_user_data(data.data.user)
                    setTimeout(() => {
                        this.$emit('authenticated', true)
                        if (this.$route.params.nextUrl != null) {
                            this.$router.push(this.$route.params.nextUrl)
                        } else if (data.data.user.home_page) {
                          this.$router.push(data.data.user.home_page)
                        } else {
                            this.$router.push('dashboard')
                        }
                        this.loading = false
                    }, 500)
                }, 500)
            },
           ...mapMutations('profile', [ 'set_user_data' ]),
        }
    }
</script>

